/* eslint-disable no-unused-vars */
import {
  InformationCircleIcon,
  LockClosedIcon,
  UserIcon,
} from '@heroicons/react/solid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import NewLogo from '../../components/layout/logo_new.png';
import { loginUser, registerUser } from '../../redux/actions/userActions';
import MessageHandler from '../../components/core/MessageHandler';
import { validatePassword } from '../../utils/password';

const RegisterForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const chooseFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const chooseLastName = (e) => {
    setLastName(e.target.value);
  };

  const chooseEmail = (e) => {
    setEmail(e.target.value);
  };

  const choosePassword = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const newError = validatePassword(newPassword, newPassword);
    setError(newError);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const registerNewUser = {
      firstName,
      lastName,
      email: email.trim(),
      password,
    };
    const { success, message } = await dispatch(registerUser(registerNewUser));
    if (!success) {
      setError(message);
      return;
    }
    await dispatch(loginUser({ email, password, remember: true }));
    setFirstName('');
    setLastName('');
    setEmail('');
    setPassword('');
    navigate('/?firstTime=True');
  };

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="max-w-lg p-8 w-full flex-col bg-white shadow-lg border-grey-input_border border-2 rounded-lg">
        <form
          onSubmit={handleFormSubmit}
          className="flex flex-col p-5 space-y-5"
        >
          <Link to={'/login'}>
            <img
              src={NewLogo}
              alt="logo"
              className="mx-auto mb-8"
              style={{ height: '50px' }}
            />
          </Link>
          <div className="flex flex-col relative">
            <label className="text-sm">
              {t('auth.login_register_first_name')}:
            </label>
            <input
              type="text"
              name="firstName"
              value={firstName}
              onChange={chooseFirstName}
              className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
              required
              placeholder="Voornaam"
            />
            <InformationCircleIcon className="w-5 absolute top-7 left-2" />
          </div>

          <div className="flex flex-col relative">
            <label className="text-sm">
              {t('auth.login_register_last_name')}:
            </label>
            <input
              type="text"
              name="lastName"
              value={lastName}
              onChange={chooseLastName}
              className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
              required
              placeholder="Achternaam"
            />
            <InformationCircleIcon className="w-5 absolute top-7 left-2" />
          </div>

          <div className="flex flex-col relative">
            <label className="text-sm">{t('email')}: </label>
            <input
              type="email"
              name="email"
              value={email}
              onChange={chooseEmail}
              className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
              required
              placeholder="Email"
            />
            <UserIcon className="w-5 absolute top-7 left-2" />
          </div>

          <div className="flex flex-col relative">
            <label className="text-sm">
              {t('auth.login_register_password')}:
            </label>
            <input
              type="password"
              name="password"
              value={password}
              onChange={choosePassword}
              className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
              required
              placeholder="Wachtwoord"
            />
            <LockClosedIcon className="w-5 absolute top-7 left-2" />
          </div>

          <button
            disabled={
              !email.length ||
              !password.length ||
              !firstName.length ||
              !lastName.length
            }
            type="submit"
            className="rounded-lg group disabled:bg-grey-medium bg-sky text-white px-2 shadow-md py-1 disabled:hover:bg-grey-medium hover:bg-sky-dark hover:shadow-md transition-colors"
          >
            <p>Registreren</p>
          </button>
          <p className="text-danger text-center h-6 w-full">{error}</p>
        </form>
        {/* Show error */}
        <p className="text-sm text-center py-2 px-5 flex space-x-1 items-center justify-center">
          <p>{t('auth.already_have_account')}</p>
          <Link to="/login" className="text-sky">
            {t('auth.login_button')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterForm;
